import React, {
  createContext,
  useState,
  ReactNode,
  useRef,
  useCallback,
} from 'react';

export const NetworkEnvContext = createContext(
  {} as [boolean, (value: boolean) => void, boolean]
);

const NetworkEnvProvider = ({ children }: { children: ReactNode }) => {
  const hasChangedIsTestnet = useRef(false);
  const [isTestnet, setIsTestnet] = useState(
    process.env.NEXT_PUBLIC_DEFAULT_NETWORK_ENV !== 'mainnet'
  );

  const changeIsTestnet = useCallback(
    (value: boolean) => {
      hasChangedIsTestnet.current = true;
      setIsTestnet(value);
    },
    [setIsTestnet]
  );

  return (
    <NetworkEnvContext.Provider
      value={[isTestnet, changeIsTestnet, hasChangedIsTestnet.current]}
    >
      {children}
    </NetworkEnvContext.Provider>
  );
};

export default NetworkEnvProvider;
